import { Box, Typography } from '@mui/material'
import { useEffect, useMemo } from 'react'

import { useCountUserMutation } from '@/@data'
import { useTranslator } from '@/hooks/useTranslator'

type UserCountResponse = {
  active?: number
  waiting?: number
  guest?: number
  blocked?: number
  waiting_delete?: number
  total?: number
}

const ICON_COLORS = {
  active: { bg: '#E9F8F1', color: '#28C76F', icon: 'tabler-user-check' },
  waiting: { bg: '#FFF5E6', color: '#FF9F43', icon: 'tabler-user-plus' },
  guest: { bg: '#EEF1FF', color: '#3551F2', icon: 'tabler-user-search' },
  blocked: { bg: '#FFECEC', color: '#EA5455', icon: 'tabler-user-x' },
  waiting_delete: { bg: '#FFECEC', color: '#EA5455', icon: 'tabler-user-off' }
} as const

const EmployeeStatistic = () => {
  const { __ } = useTranslator()

  const { mutate, data } = useCountUserMutation()

  useEffect(() => {
    mutate()
  }, [mutate])

  const counts: UserCountResponse = (data as any)?.data || (data as UserCountResponse) || {}

  const items = useMemo(
    () => [
      { key: 'active' as const, label: __('Active') },
      { key: 'waiting' as const, label: __('Pending') },
      { key: 'guest' as const, label: __('Guest') },
      { key: 'blocked' as const, label: __('Blocked') },
      { key: 'waiting_delete' as const, label: __('Waiting For Deletion') }
    ],
    [__]
  )

  return (
    <Box className='flex flex-col gap-4 p-6'>
      <Typography className='text-[18px] font-medium leading-[28px] text-[#2F2B3DE5]'>{__('Statistics')}</Typography>
      <Box
        className='grid gap-4'
        sx={{
          gridTemplateColumns: { xs: 'repeat(auto-fit, minmax(180px, 1fr))', md: 'repeat(5, minmax(0, 1fr))' }
        }}
      >
        {items.map(item => {
          const stat = ICON_COLORS[item.key]
          const value = counts[item.key] ?? 0

          return (
            <Box key={item.key} className='flex items-center gap-5 rounded-[16px]'>
              <Box
                className='h-12 w-12 flex items-center justify-center rounded-[12px]'
                sx={{ backgroundColor: stat.bg, color: stat.color }}
              >
                <i className={`${stat.icon} text-[24px]`} />
              </Box>
              <Box className='flex flex-col'>
                <Typography className='text-[18px] font-semibold text-[#2F2B3DE5] leading-[28px]'>{value}</Typography>
                <Typography className='text-[13px] text-[#2F2B3DB2] leading-[20px]'>{item.label}</Typography>
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default EmployeeStatistic
